import { URL_PARAMS_STORAGE_KEY } from '@/shared/constants/storage.constants'

export const useUrlParams = () => {
  const removeUrlParams = (params: string | string[]) => {
    const keys = Array.isArray(params) ? params : [params]

    const storedKeys: string[] = JSON.parse(sessionStorage.getItem(URL_PARAMS_STORAGE_KEY) || '[]')
    sessionStorage.setItem(
      URL_PARAMS_STORAGE_KEY,
      JSON.stringify(storedKeys.filter((key) => !keys.includes(key)))
    )

    const url = new URL(window.location.href)

    keys.forEach((key) => {
      sessionStorage.removeItem(key)
      url.searchParams.delete(key)
    })

    window.history.replaceState(window.history.state, '', url)
  }

  return { removeUrlParams }
}
